import React from "react";
import "./footer.css";

const Footer = () => {
  return <div className="footer-content">
            <p>Copyright &#9400; 2023 chandanmahato.com.np</p>
            <p>Made with React, Firebase and 💖</p>
        </div>
};

export default Footer;
